import { render } from "./MedcardDiagnosis.vue?vue&type=template&id=66cab492&scoped=true"
import script from "./MedcardDiagnosis.vue?vue&type=script&lang=js"
export * from "./MedcardDiagnosis.vue?vue&type=script&lang=js"

import "./MedcardDiagnosis.vue?vue&type=style&index=0&id=66cab492&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cab492"]])

export default __exports__